import { io } from "socket.io-client";
import config from "../config";

const socket = io(config.apiBase, {
    autoConnect: false,
    path: "/api/r2/socket.io/",
    transports: ["websocket"],
});

export default socket;